import React from 'react';
import DOMPurify from 'dompurify';
import { Log } from 'helpers/errorLogger';

export interface Props {
  html: string;
  className?: string;
  style?: React.CSSProperties;
}

const MarkdownHTML: React.FC<Props> = ({ html, className = '', style = {} }) => {
  if (typeof html !== 'string') {
    Log.error(new Error(`MarkdownHTML: Invalid html property. Expected string but received ${typeof html}`));
    return <></>;
  }

  // Sanitize the HTML to prevent XSS attacks
  const sanitizedHtml = DOMPurify.sanitize(html);

  const htmlStyles: React.CSSProperties = {
    lineHeight: '1.6',
    ...style,
  };

  return (
    <div 
      className={`prose prose-sm max-w-none prose-headings:text-inherit prose-p:text-inherit prose-strong:text-inherit prose-em:text-inherit prose-a:text-inherit ${className}`} 
      style={htmlStyles}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default MarkdownHTML;